import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "arrow_right",
  "use": "arrow_right-usage",
  "viewBox": "0 0 51 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 51 32\" id=\"arrow_right\">\r\n<title>arrow2</title>\r\n<path fill=\"#ff6b4c\" d=\"M35.429 32.089l-3.143-3.143 13.143-12.857-13.143-13.143 3.143-2.857 16 16z\" />\r\n<path fill=\"#ff6b4c\" d=\"M0 14.089h46v4.286h-46v-4.286z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol